import { Figure, Heading, Text } from 'ui/components/primitives';
import { theme, styled } from 'ui/theme';

const EmptyCart = {
  Container: styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 ${theme.space[4]};
    margin: ${theme.space[8]} 0;
    row-gap: ${theme.space[5]};
    text-align: center;
  `,

  Figure: styled(Figure)`
    max-width: ${theme.sizes[12]};
  `,

  Heading: styled(Heading)`
    color: ${theme.colors.build.brand1};
  `,

  Text: styled(Text)`
    color: ${theme.colors.build.darkDark};
  `,
};

export default EmptyCart;
